const rolesWeb = [
  {
    rol: 'CFRIO_PRE_US_ADMIN',
    accion: [{ path: '/envio', sub: null }],
    label: 'Centro directivo',
  }
];

export default rolesWeb;
